import label from "@/lang/StaticLabels.js";

export default {
  token: null,
  loginCheck: false,
  checkCode: false,
  menu: {},
  userId: null,
  userRole: null,
  requestsCount: null,

  postCheck: false,
  checkAlert: 0,
  successMessage: null,
  warningMessage: null,
  infoMessage: null,
  dangerMessage: null,

  loadingCheck: 0,
  loadingMessage: label.caption.loading,
  loadingBtn: false,

  deviceRegistrationToken: null,

};
